import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { HotTableModule } from '@handsontable/angular';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { AllTrailersComponent } from './all-trailers/all-trailers.component';
import { AssetPickupQueueComponent } from './asset-pickup-queue/asset-pickup-queue.component';
import { AssetSelectionDialogComponent } from './asset-pickup-queue/asset-selection-dialog/asset-selection-dialog.component';
import { CancelPickupDialogComponent } from './asset-pickup-queue/cancel-pickup-dialog/cancel-pickup-dialog.component';
import { AutoDispatchStatsComponent } from './auto-dispatch-stats/auto-dispatch-stats.component';
import { BolOcrAuditContainerComponent } from './bol-ocr-audit/bol-ocr-audit-container/bol-ocr-audit-container.component';
import { BolOcrAuditOrderComponent } from './bol-ocr-audit/bol-ocr-audit-order/bol-ocr-audit-order.component';
import { BolOcrAuditComponent } from './bol-ocr-audit/bol-ocr-audit.component';
import { CarrierCommitmentsComponent } from './carrier-commitments/carrier-commitments.component';
import { CompanySwitcherComponent } from './company-switcher/company-switcher.component';
import { CompanyTrailersComponent } from './company-trailers/company-trailers.component';
import { CreateDemandSnapshotComponent } from './create-demand-snapshot/create-demand-snapshot.component';
import { FiveFTourInternalDashboardComponent } from './fivef-tour-internal-dashboard/fivef-tour-internal-dashboard.component';
import { HoneyMapComponent } from './honey-map/honey-map.component';
import { InternalDashboardComponent } from './internal-dashboard/internal-dashboard.component';
import { InternalRoutingModule } from './internal-routing.module';
import { InternalShiftGraphComponent } from './internal-shift-graph/internal-shift-graph.component';
import { MineQrGeneratorComponent } from './mine-qr-generator/mine-qr-generator.component';
import { OmmaUploadModule } from './omma-upload/omma-upload.module';
import { RevenueAllocationDashboardComponent } from './revenue-allocation-dashboard/revenue-allocation-dashboard.component';
import { RevenueAllocationGraphComponent } from './revenue-allocation-graph/revenue-allocation-graph.component';
import { ShiftDailyCapRoutingModule } from './shift-daily-cap/shift-daily-cap-routing.module';
import { ShiftDailyCapComponent } from './shift-daily-cap/shift-daily-cap.component';
import { ShiftMapComponent } from './shift-map/shift-map.component';
import { ShiftTimelineComponent } from './shift-timeline/shift-timeline.component';
import { ShiftToolGraphComponent } from './shift-tool/shift-tool-graph/shift-tool-graph.component';
import { ShiftToolComponent } from './shift-tool/shift-tool.component';

@NgModule({
  declarations: [
    ShiftMapComponent,
    ShiftTimelineComponent,
    CompanySwitcherComponent,
    InternalDashboardComponent,
    InternalShiftGraphComponent,
    RevenueAllocationDashboardComponent,
    RevenueAllocationGraphComponent,
    AutoDispatchStatsComponent,
    CarrierCommitmentsComponent,
    HoneyMapComponent,
    ShiftToolComponent,
    ShiftToolGraphComponent,
    CompanyTrailersComponent,
    CreateDemandSnapshotComponent,
    AllTrailersComponent,
    FiveFTourInternalDashboardComponent,
    BolOcrAuditComponent,
    BolOcrAuditContainerComponent,
    BolOcrAuditOrderComponent,
    MineQrGeneratorComponent,
    ShiftDailyCapComponent,
    AssetPickupQueueComponent,
    AssetSelectionDialogComponent,
    CancelPickupDialogComponent,
  ],
  imports: [
    CommonModule,
    InternalRoutingModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatRippleModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    HotTableModule,
    OmmaUploadModule,
    ShiftDailyCapRoutingModule,
  ],
  exports: [ShiftMapComponent, CompanySwitcherComponent],
})
export class InternalModule {}
